import { getRouteApi } from '@tanstack/react-router';

import type { Estates } from '@/features/estates/api/estates';
import { EstateGrid } from '@/features/estates/components/estate-grid';
import { EstatesList } from '@/features/estates/components/estate-list';
import { EstatesMap } from '@/features/estates/components/estate-map';
import { useTenantEstates } from '@/features/tenants/api/tenant-estates';
import { parseSearchParamsToSearchQuery } from '@/utils/parseSearchParamsToSearchQuery';

const route = getRouteApi('/_authenticated/_sidebar-layout/tenant/$tenantId/estates');

export const TenantEstateSection = () => {
  const { tenantId } = route.useParams();
  const { view, filters, sort } = route.useSearch();

  const parsedFilters = parseSearchParamsToSearchQuery(filters);
  const { data, isFetching } = useTenantEstates({
    id: tenantId,
    args: [
      {
        query: {
          ...(Object.keys(parsedFilters).length ? { filters: parsedFilters } : {}),
          pageSize: view === 'map' ? 999 : 20,
          ...(sort &&
            (sort.by || sort.order) && {
              sort: {
                ...(sort.by && { by: sort.by }),
                ...(sort.order && { order: sort.order }),
              },
            }),
        },
      },
    ],
  });

  if (!data) return null;

  if (view === 'grid') {
    return <EstateGrid data={data as Estates} />;
  } else if (view === 'map') {
    return <EstatesMap data={data as Estates} isPending={isFetching} />;
  }

  return <EstatesList route={route} data={data as Estates} />;
};
